import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // Reset scroll just in case browser remembered previous scroll
      window.scrollTo(0, 0);
    };

    // Delay to allow new page/layout to render
    const timeout = setTimeout(handleScroll, 100);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
}
